const BPS_UNITS = ["bps", "Kbps", "Mbps", "Gbps"] as const;
const BYTE_UNITS = ["B", "KB", "MB", "GB", "TB"] as const;

/**
 * Format bytes/s ke bps/Kbps/Mbps/Gbps.
 */
export function formatBps(bytesPerSecond: number): string {
  let bitsPerSecond = bytesPerSecond * 8;
  let unitIndex = 0;

  while (bitsPerSecond >= 1000 && unitIndex < BPS_UNITS.length - 1) {
    bitsPerSecond /= 1000;
    unitIndex++;
  }

  const formatted = Number(bitsPerSecond.toFixed(2)).toString();
  return `${formatted} ${BPS_UNITS[unitIndex]}`;
}

/**
 * Format bytes ke B/KB/MB/GB/TB.
 */
export function formatBytes(bytes: number): string {
  if (bytes === 0) return "0 B";

  let value = bytes;
  let unitIndex = 0;

  while (value >= 1024 && unitIndex < BYTE_UNITS.length - 1) {
    value /= 1024;
    unitIndex++;
  }

  const formatted = Number(value.toFixed(2)).toString();
  return `${formatted} ${BYTE_UNITS[unitIndex]}`;
}

/**
 * Format milliseconds dengan 1 angka desimal.
 */
export function formatMs(ms: number): string {
  return `${Number(ms).toFixed(1)} ms`;
}

/**
 * Format ISO timestamp ke format lokal Indonesia:
 * "15/01/2025 14:30:25"
 */
export function formatTimestamp(iso: string): string {
  const date = new Date(iso);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

/**
 * Format relative time dalam Bahasa Indonesia.
 */
export function formatTimeAgo(iso: string): string {
  const seconds = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);

  if (seconds < 10) return "baru saja";
  if (seconds < 60) return `${seconds} detik yang lalu`;

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} menit yang lalu`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} jam yang lalu`;

  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} hari yang lalu`;

  const months = Math.floor(days / 30);
  if (months < 12) return `${months} bulan yang lalu`;

  const years = Math.floor(months / 12);
  return `${years} tahun yang lalu`;
}

/**
 * Format range string ke label Bahasa Indonesia.
 */
export function formatRange(range: string): string {
  switch (range) {
    case "6h":
      return "6 Jam";
    case "12h":
      return "12 Jam";
    case "24h":
      return "24 Jam";
    case "7d":
      return "7 Hari";
    case "30d":
      return "30 Hari";
    case "45d":
      return "45 Hari";
    default:
      return range;
  }
}
